<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [class]="'kt-portlet__head--lg'">
		<ng-container ktPortletTitle>
			<h3 class="kt-portlet__head-title">
				<span>Price Change</span>
			</h3>
		</ng-container>

	</kt-portlet-header>
	<div class="kt-portlet__body pl-5 pr-3">
		<div *ngIf="priceChange && priceChange.recipes">
		<!-- <div *ngIf="priceChange"> -->
			<div class="row mt-1 mb-4" *ngIf="priceChangeObservable$ | async as priceChange">
				<div class="col">
					<span class="badge badge-pill badge-success">Updated by</span> &nbsp;{{priceChange.updated_by}}
				</div>
				<div class="col">
					<span class="badge badge-pill badge-success">Updated At</span> &nbsp;{{priceChange.updated_at | date:'MM/dd/yy hh:mm:ss a'}}
				</div>
				<div class="col">
					<span class="badge badge-pill badge-success">Applied At</span> &nbsp;{{priceChange.applied_at | date:'MM/dd/yy hh:mm:ss a'}}
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-12">
					<div class="pricing-template bg-light border rounded px-4 py-3">
						<div class="pricing-template__copy">
							<div class="font-weight-bold">
								Pricing template
								<span *ngIf="appliedPricingTemplate" class="badge badge-pill badge-primary ml-2">{{appliedTemplateLabel}} applied</span>
							</div>
							<div class="text-muted small">Fills the New Price column. Review the values, then Submit to apply.</div>
						</div>
						<div class="pricing-template__actions">
							<button
								mat-raised-button
								color="primary"
								type="button"
								(click)="applyPricingTemplate('default')">
								Default
							</button>
							<button
								mat-raised-button
								color="primary"
								type="button"
								(click)="applyPricingTemplate('airport')">
								Airport
							</button>
							<button
								mat-raised-button
								color="primary"
								type="button"
								(click)="applyPricingTemplate('dollarCoffeeDay')">
								$1 Coffee Day
							</button>
							<button
								mat-stroked-button
								color="warn"
								type="button"
								class="pricing-template__clear"
								(click)="clearPrices()">
								Clear
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="row font-weight-bold">
				<div class="col">
					Recipe Name
				</div>
				<div class="col">
					Current Price
				</div>
				<div class="col">
					New Price
				</div>
			</div>
			<hr>
			<div *ngIf="priceChangeObservable$ | async as priceChange">

			<div class="row mt-1" *ngFor="let item of _recipes; let i = index">
			<!-- <div class="row mt-1" *ngFor="let item of priceChange.recipes; let i = index; trackBy: trackByIndex"> -->

				<div class="col">
					{{item.name}}
				</div>
				<div class="col">
					${{item.oldPrice}}
				</div>
				<div class="col">
					<mat-form-field>
						<span matPrefix>$ &nbsp;</span>
						<!-- <input matInput type="text" [(ngModel)]="priceChange.recipes[i].price"/> -->
						<input matInput type="text" [(ngModel)]="item.price"/>
					</mat-form-field>
				</div>
			</div>
			</div>
			<div class="text-right mt-3" class="row">
				<button mat-raised-button type="button" (click)="onBack()" color="warn" class="ml-auto">Back</button> &nbsp;
				<button mat-raised-button class="mr-5" (click)="onSubmit()" color="primary">Submit</button>
			</div>
		</div>
	</div>
</div>
